import { maSessionStorage } from '@/lib/storage'
import { RouteName } from '@/base/constants/route'
import { AUTH_PLATFORM } from '@/base/constants/Auth'

const isSearchAdsUrl = path => path.endsWith('/searchads')

/**
 * Route guard that checks if the user is accessing a `searchads` URL and stores
 * the platform information in session storage on the first visit. If the user is
 * not coming from a known route and the current path is not `searchads`, it clears
 * the platform data from session storage.
 *
 * @param {object} to - The target route object where the user is navigating to.
 * @param {object} from - The route object from where the navigation is initiated.
 * @param {Function} next - The function to be called to proceed with the navigation.
 *
 * @returns {void}
 *
 * @example
 * @to.path example: '/auth/login/searchads'
 *
 * @description
 * - If the target URL ends with `/searchads`, it stores the platform as `AUTH_PLATFORM.SA` in session storage.
 * - If this is the first navigation (i.e., no `from.name`) and the target route is not an auth callback,
 *   it deletes the platform from session storage.
 */
export function platformGuard(to, from, next) {
  const callbackRouteNames = [RouteName.AUTH_CALLBACK]

  if (isSearchAdsUrl(to.path)) {
    maSessionStorage.platform = AUTH_PLATFORM.SA
  }
  else if (!from.name && !callbackRouteNames.includes(to.name)) {
    maSessionStorage.platform = null
  }

  next()
}
